var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activities-status-icon-button" },
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            disabled: _vm.tooltipDisabled,
            arrow: false,
            content: _vm.tooltipContent,
            contentClass: _vm.tooltipContentClass,
            placement: _vm.tooltipPlacement
          }
        },
        [
          _c("CompassIconButton", {
            class: _vm.iconClass,
            attrs: {
              size: _vm.size,
              icon: _vm.icon,
              loading: _vm.pending,
              disabled: _vm.disabled && !_vm.pending,
              "data-bot": "activities-listing__action-status-icon-button"
            },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.toggleStatus($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }